import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion'
import { fadeIn } from '../../variants'
import Glide, { Controls, Breakpoints } from '@glidejs/glide/dist/glide.modular.esm';
import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';
// Import all images dynamically from the folder
function importAll(r) {
  let images = {};
  r.keys().forEach((item, index) => { images[item.replace('./', '')] = r(item); });
  return images;
}

const images = importAll(require.context('../../assets/morifarm', false, /\.(png|jpe?g|svg|avif)$/));

function GalleryMorifarm() {
  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    const imageElements = document.querySelectorAll('.image-slider');
    const totalImages = imageElements.length;
    let loadedImages = 0;

    function onImageLoad() {
      loadedImages += 1;
      if (loadedImages === totalImages) {
        setImagesLoaded(true);
      }
    }

    imageElements.forEach(image => {
      if (image.complete) {
        onImageLoad();
      } else {
        image.addEventListener('load', onImageLoad);
        image.addEventListener('error', onImageLoad); // Consider it loaded even if there's an error
      }
    });

    return () => {
      imageElements.forEach(image => {
        image.removeEventListener('load', onImageLoad);
        image.removeEventListener('error', onImageLoad);
      });
    };
  }, []);

  useEffect(() => {
    if (imagesLoaded) {
      const glide = new Glide('.glide', {
        type: 'carousel',
        startAt: 0,
        perView: 1,
        focusAt: 'center',
        gap: 10,
        swipeThreshold: 80,
        dragThreshold: 120,
        perTouch: 1,
        touchRatio: 0.5,
        animationDuration: 400,
        rewind: true,
      }).mount({ Controls, Breakpoints });
      return () => glide.destroy();
    }
  }, [imagesLoaded]);

  return (
    <div className="container mx-auto flex flex-col xl:flex-row gap-10 my-5 min-h-screenD">
      <motion.div
        variants={fadeIn('right', 0.5)}
        initial="hidden"
        whileInView={'show'}
        viewport={{ once: false, amount: 0.3 }}
        className='max-w-[400px]'>
        <h2 className='h2 leading-tight text-accent'>
          Morifarm
        </h2>
        <p className='max-w-sm mb-4'>
          Developed Front-end UI from scratch using Vue JS for
          Mori Farm of Brunei Darussalam.
          Used Vuetify to create a beautifully themed UI.
        </p>
        <p>Website: <a href="https://mori.farm/" className='text-cyan-400' rel="noreferrer" target="_blank">https://mori.farm/</a></p>

        <p> Tech stack: Vue.js and Vuetify</p>
      </motion.div>
      <motion.div
        variants={fadeIn('left', 0.5)}
        initial="hidden"
        whileInView={'show'}
        viewport={{ once: false, amount: 0.3 }}
        className="max-w-[800px]">
        <div className="glide">
          <div className="glide__track" data-glide-el="track">
            <ul className="glide__slides">
              {Object.keys(images).map((key, index) => (
                <li className="glide__slide" key={index}>
                  <img className="image-slider" src={images[key]} alt={`Slide ${index}`} />
                </li>
              ))}
            </ul>
          </div>
          <div className="glide__arrows" data-glide-el="controls">
            <button className="glide__arrow glide__arrow--left btn btn-slider" data-glide-dir="<">Prev</button>
            <button className="glide__arrow glide__arrow--right btn btn-slider" data-glide-dir=">">Next</button>
          </div>
        </div>
      </motion.div>
    </div >
  );
}

export default GalleryMorifarm;
